module.exports = __webpack_public_path__ + "static/media/game-forewordbutton.e8f3b528.png";